import React from 'react'
import { Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { get } from 'styled-system'
import { theme } from '../../../../theme'

const CustomNavLink = React.forwardRef<HTMLAnchorElement, NavLinkProps>((props, ref) => {
  return <NavLink ref={ref} {...props} />
})

const MotionLink = motion(CustomNavLink as any)

type MenuItemProps = {
  color?: string
  bg?: string
  width?: string
  alignItems?: string
  accentcolor?: string
  hovercolor?: string
}

const { colors } = theme

export const Tooltip = styled(Flex)`
  opacity: 0;
  left: 64px;
  border-radius: 0;
  visibility: hidden;
  position: absolute;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transform: translateX(10px);
  padding: 2rem;
  &:after {
    top: 50%;
    width: 0;
    margin: 0;
    height: 0;
    left: -5px;
    content: '';
    line-height: 0;
    position: absolute;
    transform: translateY(-50%);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid ${theme.colors.gray[800]};
  }
`

export const MenuItem = styled(MotionLink as any)<MenuItemProps>`
  height: 44px;
  display: flex;
  color: ${theme.colors.green[500]};
  position: relative;
  align-items: ${(props) => props.alignItems || 'center'};
  white-space: nowrap;
  background: transparent;
  justify-content: center;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  width: ${(props) => props.width || '100%'};
  border-radius: 0;
  border-left: 2px solid transparent;
  overflow: visible;

  & .icon-wrap {
    color: ${theme.colors.green[500]};
  }
  &.active-nav-link {
    color: ${theme.colors.green[900]};
    background-color: ${theme.colors.green[100]};
    border-left-color: ${theme.colors.green[900]};
  }
  &.active-nav-link .icon-wrap {
    color: ${theme.colors.green[900]};
  }

  & .icon-wrap svg {
    stroke: ${(props) => get(colors, props.color || '', props.color || theme.colors.green[500])};
  }
  &:hover {
    cursor: pointer;
    color: ${theme.colors.green[900]};
    background: ${theme.colors.green[50]};
    border-left-color: ${theme.colors.green[400]};
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  &:hover .sidebar-tooltip {
    opacity: 1;
    width: auto;
    padding: 5px 10px;
    visibility: visible;
    transform: translateX(0);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
`
